import { defineMessages } from "react-intl";

// Override tenant-specific values in "ploy-ui/tenants/src/tenants/<tenant>/translations/<lang>.json"

export default defineMessages({
	// GENERIC Fields:
	"Generic.HouseholdInfo": {
		id: "labels.Generic.HouseholdInfo",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.HouseholdInfo'"
	},
	"Generic.RefinanceInformation": {
		id: "labels.Generic.RefinanceInformation",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.RefinanceInformation'"
	},
	"Generic.MainResidenceFoundText": {
		id: "labels.Generic.MainResidenceFoundText",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.MainResidenceFoundText'"
	},
	"Generic.AutomaticPriceEstimateInfoText": {
		id: "labels.Generic.AutomaticPriceEstimateInfoText",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.AutomaticPriceEstimateInfoText'"
	},
	"Generic.IncomeIsAutomaticallyFetchedText": {
		id: "labels.Generic.IncomeIsAutomaticallyFetchedText",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.IncomeIsAutomaticallyFetchedText'"
	},
	"Generic.ConsentInfo": {
		id: "labels.Generic.ConsentInfo",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.ConsentInfo'"
	},
	"Generic.LoanAmountInfoText": {
		id: "labels.Generic.LoanAmountInfoText",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.LoanAmountInfoText'"
	},
	"Generic.SummaryInfoText": {
		id: "labels.Generic.SummaryInfoText",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.SummaryInfoText'"
	},
	"Generic.YourProperty": {
		id: "labels.Generic.YourProperty",
		defaultMessage: "Label from frontend translation resource",
		description: "Custom label for 'Generic.YourProperty'"
	},
	"Generic.YourPropertyPurchase": {
		id: "labels.Generic.YourPropertyPurchase",
		defaultMessage: "Label from frontend translation resource",
		description: "Cusom label for 'Generic.YourPropertyPurchase'"
	}
});
